export interface RankItem {
  rank: number;
  name: string;
  version: string;
  tag: string;
  heat: string;
  score: string;
  platform: string[];
  summary: string;
  status: "hot" | "new" | "normal";
}

export interface ReleaseItem {
  id: string;
  name: string;
  version: string;
  date: string;
  platform: string[];
  size: string;
  summary: string;
  log: string;
}

export interface FeaturedItem {
  name: string;
  category: string;
  sub: string;
  desc: string;
  img: string;
  count: string;
}

export interface LogItem {
  date: string;
  type: string;
  app: string;
  version: string;
  text: string;
}

export interface ChannelItem {
  icon: string;
  title: string;
  desc: string;
  count: string;
  accent: string;
}

export interface GuideItem {
  no: string;
  icon: string;
  title: string;
  summary: string;
  steps: string[];
}

export const hotRank: RankItem[] = [
  { rank: 1, name: "瓜田速递", version: "v3.8.2", tag: "今日热榜", heat: "48.6万", score: "4.9", platform: ["安卓", "苹果"], summary: "全网热榜即时聚合，一眼扫完当天最热瓜点与讨论走势，支持关键词直达。", status: "hot" },
  { rank: 2, name: "今晚瓜棚", version: "v2.4.0", tag: "夜间精选", heat: "39.2万", score: "4.8", platform: ["安卓", "苹果"], summary: "夜间话题精选剧场，睡前两分钟看完当天焦点速评，支持离线缓存。", status: "hot" },
  { rank: 3, name: "热浪头条 Pro", version: "v6.1.0", tag: "多源加权", heat: "33.7万", score: "4.8", platform: ["安卓"], summary: "多源热搜加权排序，热度走势曲线直观呈现，资讯刷新零延迟。", status: "hot" },
  { rank: 4, name: "见闻聚焦", version: "v5.0.1", tag: "图文直出", heat: "27.4万", score: "4.7", platform: ["安卓", "苹果"], summary: "图片与视频一键原图保存，浏览记录本地留存，二次打开更流畅。", status: "normal" },
  { rank: 5, name: "榜前资讯", version: "v4.2.3", tag: "早晚双报", heat: "21.8万", score: "4.6", platform: ["苹果"], summary: "早报晚报双档推送，自选话题关键词订阅，重要更新直达提醒。", status: "normal" },
  { rank: 6, name: "速览热搜", version: "v7.0.0", tag: "护眼夜间", heat: "18.5万", score: "4.7", platform: ["安卓"], summary: "深色护眼夜间模式，极简无广告浏览体验，内存占用低至 38MB。", status: "new" },
  { rank: 7, name: "深夜热闻", version: "v3.1.1", tag: "深夜专栏", heat: "16.9万", score: "4.5", platform: ["安卓", "苹果"], summary: "深夜话题专栏集锦，编辑精选当周值得回看的长文与讨论。", status: "normal" },
  { rank: 8, name: "话题雷达", version: "v1.9.0", tag: "趋势捕捉", heat: "12.3万", score: "4.5", platform: ["安卓"], summary: "实时捕捉上升话题，早于榜单的发现体验，自带趋势指数评估。", status: "normal" },
  { rank: 9, name: "瓜田日历", version: "v2.0.3", tag: "日程版", heat: "9.6万", score: "4.4", platform: ["苹果"], summary: "把重要瓜点排进日程，按时间轴回顾每周大事，不遗漏任何节点。", status: "normal" },
  { rank: 10, name: "轻览热讯", version: "v3.5.7", tag: "轻量极速", heat: "8.1万", score: "4.6", platform: ["安卓"], summary: "轻量级资讯浏览器，冷启动 0.8 秒，包体仅 22MB 全功能可用。", status: "normal" },
];

export const latestReleases: ReleaseItem[] = [
  { id: "r1", name: "瓜田速递", version: "3.8.2", date: "2026.09.06", platform: ["安卓", "苹果"], size: "48.6MB", summary: "新增热点时间线回看，热榜刷新提速，修复部分机型推送延迟。", log: "优化首页榜单加载，秒开浏览" },
  { id: "r2", name: "速览热搜", version: "7.0.0", date: "2026.09.04", platform: ["安卓"], size: "38.2MB", summary: "全面接入夜间护眼模式，重构极简信息流，广告位进一步收敛。", log: "深色模式 + 极简流重构" },
  { id: "r3", name: "今晚瓜棚", version: "2.4.0", date: "2026.09.02", platform: ["安卓", "苹果"], size: "52.1MB", summary: "新增离线下载与合集收藏，支持倍速播放与后台下载。", log: "离线缓存 + 合集收藏上线" },
  { id: "r4", name: "榜前资讯", version: "4.2.3", date: "2026.08.30", platform: ["苹果"], size: "41.7MB", summary: "优化早报生成逻辑，修复消息角标与部分订阅推送异常。", log: "订阅推送稳定性提升" },
  { id: "r5", name: "见闻聚焦", version: "5.0.1", date: "2026.08.27", platform: ["安卓", "苹果"], size: "63.4MB", summary: "图片原图保存改为默认开启，新增压缩传输选项节省流量。", log: "原图直出 + 流量优化" },
  { id: "r6", name: "轻览热讯", version: "3.5.7", date: "2026.08.24", platform: ["安卓"], size: "22.0MB", summary: "冷启动速度再提升，修复夜间模式下的部分渲染色差问题。", log: "冷启动提速至 0.8 秒" },
];

export const featuredPicks: FeaturedItem[] = [
  { name: "早报全知道", category: "早晚速读", sub: "每天 5 分钟掌握焦点", desc: "精选当日值得关注的瓜点，按时段整理成早报卡片，通勤路上即可读完。", img: "https://readdy.ai/api/search-image?query=editorial%20news%20digest%20cover%20illustration%20soft%20coral%20red%20and%20cream%20tones%20morning%20newspaper%20with%20phone%20and%20coffee%20clean%20minimal%20warm%20lighting%20modern%203d%20scene%20high%20detail&width=800&height=560&seq=chigua-feat-01&orientation=landscape", count: "86 篇 · 每日更新" },
  { name: "榜单研究室", category: "热度分析", sub: "读懂每一次热度涨跌", desc: "用可视化曲线还原热点如何发酵，从时间、渠道、人群三层拆解涨跌原因。", img: "https://readdy.ai/api/search-image?query=modern%20data%20trend%20analysis%20illustration%20line%20charts%20and%20ranking%20bars%20in%20warm%20coral%20amber%20and%20green%20on%20cream%20background%20clean%20minimal%20editorial%203d%20render%20high%20detail&width=800&height=560&seq=chigua-feat-02&orientation=landscape", count: "32 期 · 每周更新" },
  { name: "夜间放映厅", category: "深夜专栏", sub: "值得二刷的长文回顾", desc: "把当周值得细看的深度内容重新编排，睡前阅读也有一个安静的出口。", img: "https://readdy.ai/api/search-image?query=cozy%20night%20reading%20magazine%20illustration%20warm%20amber%20lamplight%20armchair%20and%20book%20on%20deep%20background%20moody%20yet%20clean%20minimal%203d%20style%20high%20detail&width=800&height=560&seq=chigua-feat-03&orientation=landscape", count: "24 期 · 每周更新" },
  { name: "装机第一步", category: "新手指南", sub: "下载安装不踩坑", desc: "安卓、苹果双端从零讲清安装与信任设置，配图分步演示，看完就会。", img: "https://readdy.ai/api/search-image?query=phone%20setup%20guide%20illustration%20two%20smartphones%20android%20and%20ios%20with%20install%20steps%20soft%20cream%20and%20green%20accent%20clean%20minimal%20editorial%203d%20high%20detail&width=800&height=560&seq=chigua-feat-04&orientation=landscape", count: "12 篇 · 持续更新" },
];

export const changelog: LogItem[] = [
  { date: "09.06", type: "版本", app: "瓜田速递", version: "3.8.2", text: "热点时间线回看功能上线，榜单加载提速 40%。" },
  { date: "09.04", type: "版本", app: "速览热搜", version: "7.0.0", text: "夜间护眼模式 + 极简信息流全面上线，广告位收敛。" },
  { date: "09.02", type: "专题", app: "早报全知道", version: "—", text: "本周早报新增「昨日回放」栏目，可复盘错过的瓜点。" },
  { date: "08.30", type: "版本", app: "榜前资讯", version: "4.2.3", text: "修复订阅推送角标异常，早报生成逻辑优化。" },
  { date: "08.27", type: "安全", app: "全站检测", version: "—", text: "本周共检测 46 个安装包，全部通过安全校验并更新指纹库。" },
  { date: "08.24", type: "版本", app: "轻览热讯", version: "3.5.7", text: "冷启动提速至 0.8 秒，修复夜间渲染色差问题。" },
];

export const channels: ChannelItem[] = [
  { icon: "ri-android-fill", title: "安卓下载", desc: "APK 安装包直取，适配主流机型", count: "238 款", accent: "primary" },
  { icon: "ri-apple-fill", title: "苹果 iOS", desc: "企业签名 + 信任指引全流程", count: "156 款", accent: "accent" },
  { icon: "ri-sparkling-2-fill", title: "最新版本", desc: "每次更新第一时间上架", count: "12 个今日", accent: "secondary" },
  { icon: "ri-history-line", title: "历史版本", desc: "旧版兼容包随时可回退", count: "600+", accent: "primary" },
  { icon: "ri-computer-line", title: "桌面版", desc: "Windows / Mac 客户端支持", count: "38 款", accent: "accent" },
  { icon: "ri-tools-line", title: "装机工具箱", desc: "去残留、清缓存、权限体检", count: "21 款", accent: "secondary" },
];

export const guideItems: GuideItem[] = [
  { no: "01", icon: "ri-android-fill", title: "安卓下载与安装", summary: "从下载到打开，三条路径任选，规避安全风险。", steps: ["下载后打开安装包", "允许「未知来源」提示", "安装完成即可使用"] },
  { no: "02", icon: "ri-apple-fill", title: "iOS 信任与验证", summary: "苹果端签名安装，三步信任证书即可正常打开。", steps: ["完成下载后进入设置", "通用 · VPN 与设备管理", "信任对应描述文件"] },
  { no: "03", icon: "ri-refresh-line", title: "版本更新说明", summary: "版本号规则与更新提醒设置，怎么追最新版本一目了然。", steps: ["开启自动更新提醒", "按版本号识别新旧", "保留稳定旧版可回退"] },
  { no: "04", icon: "ri-shield-check-line", title: "安全与病毒检测", summary: "官网直发 + 双重校验，安装前先看一眼扫描结果。", steps: ["核对文件哈希值", "查看官方签名证书", "提交可疑包人工复核"] },
];